import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LabReqField, LabReqTestOption } from '@care-portals/api-interfaces';

@Component({
  selector: 'my-health-input-group',
  templateUrl: './input-group.component.html',
  styleUrls: ['./input-group.component.less']
})
export class InputGroupComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() testId: string;
  @Input() options: Array<LabReqTestOption>;
  @Input() headerStyle: string;
  @Input() inputColor: string;
  @Input() values: object;
  fields: Array<LabReqField>;
  labForm!: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.values) {
      const values = changes.values.currentValue;
      if (!values) {
        return;
      }
      this.setValues();
    }
  }

  setValues(): void {
    const values = this.values;
    let formValues = {};
    Object.keys(values).map((key, index) => {
      formValues = {
        ...formValues,
        [key || `unknown${index}`]: values[key]
      };
    });
    if (this.labForm) {
      this.labForm.patchValue(formValues);
    }
  }

  ngOnInit(): void {
    if (!this.testId) {
      console.error('Test id is missing');
    }
    const fields: Array<LabReqField> = [];
    this.options.forEach(option => {
      fields.push({
        id: Math.random().toString().slice(2),
        label: '',
        type: 'break'
      });
      fields.push({
        id: this.testId + '_' + option.id,
        label: option.label,
        type: option.type,
        required: option.required ?? false,
        level: option.children ? 'parent' : undefined,
        elements: option.elements,
        children:
          option.children?.map(child => ({
            id: this.testId + '_' + option.id + '_' + child.id,
            label: child.label,
            type: child.type,
            required: child.required ?? false,
            level: 'child'
          })) ?? []
      });
    });
    this.fields = fields;

    const groupItems = {};
    this.fields.forEach(field => {
      Object.assign(groupItems, {
        [field.id]: [
          field.type === 'string' ? '' : field.type === 'number' ? 0 : null,
          field.required ? Validators.required : null
        ]
      });
      if (field.children) {
        field.children.forEach(childField => {
          Object.assign(groupItems, {
            [childField.id]: [
              {
                disabled: true,
                value:
                  childField.type === 'string'
                    ? ''
                    : childField.type === 'number'
                    ? 0
                    : null
              },
              childField.required ? Validators.required : null
            ]
          });
        });
      }
    });

    this.labForm = this.formBuilder.group(groupItems);
    this.setValues();
  }
}
